import { defineMessages } from 'react-intl';

export default defineMessages({
    serviceRequest: {
        id: 'tdic.servicerequest.detail.Service Request',
        defaultMessage: 'Service Request'
    },
    accountHolder: {
        id: 'tdic.servicerequest.detail.Accountholder',
        defaultMessage: 'Accountholder'
    },
    requestDetails: {
        id: 'tdic.servicerequest.detail.Please provide us with the details of your request',
        defaultMessage: 'Please enter the details of your service request with as much information as possible. Your agent will make every effort to contact you within your desired day/time. '
    },
    requestLabel: {
        id: 'tdic.servicerequest.Select Request Type',
        defaultMessage: 'Select Request Type'
    },
    policyChange: {
        id: 'tdic.servicerequest.detail.Request a policy change',
        defaultMessage: 'Request a policy change'
    },
    thirdParty: {
        id: 'tdic.servicerequest.Contact a third party about my policy',
        defaultMessage: 'Contact a third party about my policy'
    },
    claimsHistory: {
        id: 'tdic.servicerequest.Request my claims history',
        defaultMessage: 'Request my claims history'
    },
    insuranceReview: {
        id: 'tdic.servicerequest.Request insurance review',
        defaultMessage: 'Request insurance review'
    },
    otherQuestions: {
        id: 'tdic.servicerequest.Other policy questions',
        defaultMessage: 'Other policy questions'
    },
    selectPolicy: {
        id: 'tdic.servicerequest.Select Policy',
        defaultMessage: 'Select Policy'
    },
    propertyLocation: {
        id: 'tdic.servicerequest.Property Location',
        defaultMessage: 'Property Location'
    },
    detailsOfRequest: {
        id: 'tdic.servicerequest.Details of request',
        defaultMessage: 'Details of Request'
    },
    timeToContactTitle: {
        id: 'tdic.servicerequest.Best time to contact me Title',
        defaultMessage: 'Best time to contact me'
    },
    timeToContactSubTitle: {
        id: 'tdic.servicerequest.Best time to contact me Sub-Title',
        defaultMessage: '(Date, Start Time, End Time)'
    },
    termsOfUse: {
        id: 'tdic.servicerequest.By checking this box, I agree to the',
        defaultMessage: 'By checking the signature box, I agree to the {link}.'
    },
    termsAndConditions: {
        id: 'tdic.servicerequest.Terms and conditions',
        defaultMessage: 'Terms and conditions'
    },
    cancelButton: {
        id: 'tdic.servicerequest.Cancel',
        defaultMessage: 'Cancel'
    },
    saveButton: {
        id: 'tdic.servicerequest.Submit',
        defaultMessage: 'Submit'
    },
    modalTitle: {
        id: 'tdic.servicerequest.Your Service Request has been submitted successfully.',
        defaultMessage: 'Your Service Request has been submitted successfully.'
    },
    tdicReference: {
        id: 'tdic.servicerequest.Thank you for being a TDIC policyholder.',
        defaultMessage: 'Your agent will contact you to confirm any additional information needed.\n\nPlease print and save a copy of this request for your records.\nThank you for being a TDIC policyholder.'
    },
    selectTypeOfChange: {
        id: 'tdic.servicerequest.Select Type of Policy Change',
        defaultMessage: 'Select Type of Policy Change'
    },
    underwritingApproval: {
        id: 'tdic.servicerequest.All policy change requests will be reviewed by',
        defaultMessage: 'All policy change requests will be reviewed by your agent and require underwriting approval to take affect.'
    },
    reasonRequest: {
        id: 'tdic.servicerequest.Reason for request',
        defaultMessage: 'Reason for Request'
    },
    printRequest: {
        id: 'tdic.servicerequest.Print Service Request',
        defaultMessage: 'Print Service Request'
    },
    backHomePage: {
        id: 'tdic.servicerequest.Back to Home Page',
        defaultMessage: 'Back to Home Page'
    },
    errorNotificationMessage: {
        id: 'tdic.servicerequest.Start time is before current time or end time is before start time',
        defaultMessage: 'Start time is before current time or end time is before start time'
    },
    noWeekendsErrorMessage: {
        id: 'tdic.servicerequest.Date is not an available business day',
        defaultMessage: 'Date is not an available business day'
    },
    errorTitle: {
        id: 'tdic.servicerequest.Service request cannot be submitted',
        defaultMessage: 'Service request cannot be submitted'
    },
    errorMessage: {
        id: 'tdic.servicerequest.Your Service request cannot be submitted.',
        defaultMessage: 'Your Service request cannot be submitted.'
    },
    errorMessageCancel: {
        id: 'tdic.servicerequest.OK',
        defaultMessage: 'OK'
    },
    preferredContact: {
        id: 'tdic.servicerequest.detail.Preferred contact method',
        defaultMessage: 'Preferred contact method'
    },
    preferredContactAddress: {
        id: 'tdic.servicerequest.detail.phone number or email address',
        defaultMessage: 'i.e., phone number or email address'
    },
    canNotLoadServiceRequest: {
        id: 'tdic.servicerequest.detail.Sorry we can not load service request at this time',
        defaultMessage: 'Sorry we can not load service request at this time'
    },
    serviceRequestFailed: {
        id: 'tdic.servicerequest.detail.ERROR',
        defaultMessage: 'ERROR'
    },
    dateSelect: {
        id: 'tdic.servicerequest.date-select.Please Select',
        defaultMessage: 'Please Select'
    }
});
